import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toggleSidebar } from '../../actions';
import { Link } from 'react-router-dom';
import NavBar from '../layout/NavBar';
import PharmacyOrdersTable from './PharmacyOrdersTable.jsx';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import { PageHeader } from '../common/PageHeader';
import { createGlobalStyle } from 'styled-components';
import UploadRxModal from './UploadRxModal';
import AddApolloMedicineModal from './AddApolloMedicineModal.js'
import RefundOrderModal from './RefundOrderModal.js'
import RefundBankAmountModal from './RefundBankAmountModal.jsx'
import OpsAnalyticsModal from './OpsAnalyticsModal.jsx'

const GlobalStyles = createGlobalStyle`
  .DateRangePicker_picker {
    z-index: 2147483647 !important;
  }
  .DateRangePickerInput {
    border: 1px solid #E3E3E3 !important;
    border-radius: 6px !important;
    background: #FAFAFA !important;
    display: flex !important;
    align-items: center !important;
    height: 36px !important;
    padding: 0 8px !important;
  }
  .DateRangePickerInput_arrow {
    color: #A5A6BB !important;
  }
  .DateInput {
    background: transparent !important;
    width: 90px !important;
  }
  .DateInput_input {
    font-size: 12px !important;
    font-weight: 600 !important;
    color: #0F0B28 !important;
    background: transparent !important;
    border-bottom: none !important;
    padding: 0 4px !important;
    height: 34px !important;
  }
  .DateInput_input__focused {
    border-bottom: 2px solid #6C5DD3 !important;
  }
  .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    background: #6C5DD3 !important;
    border-color: #6C5DD3 !important;
  }
  .CalendarDay__selected_span {
    background: #E5E9FE !important;
    border-color: #CFC8FF !important;
    color: #6C5DD3 !important;
  }
  .CalendarDay__hovered_span,
  .CalendarDay__hovered_span:hover {
    background: #F5F4FF !important;
    border-color: #CFC8FF !important;
    color: #6C5DD3 !important;
  }
  .DayPickerNavigation_button__default {
    border-color: #E3E3E3 !important;
  }
  .pharmacy-orders-page .revamp-table.ReactTable .rt-th,
  .pharmacy-orders-page .revamp-table.ReactTable .rt-td {
    font-weight: 600 !important;
  }
  .pharmacy-orders-page .revamp-table.ReactTable .rt-thead.-filters input,
  .pharmacy-orders-page .revamp-table.ReactTable .rt-thead.-filters select {
    font-weight: 500 !important;
  }

  /* ── Mobile ── */
  @media (max-width: 640px) {
    .po-content { padding: 8px 10px 24px !important; }
    .po-filter-bar { flex-direction: column !important; align-items: stretch !important; gap: 8px !important; }
    .po-filter-bar .po-divider { display: none !important; }
    .po-filter-bar .po-search-wrap { width: 100% !important; }
    .po-filter-bar .po-search-wrap input { width: 100% !important; }
    .po-filter-bar .po-date-group { width: 100% !important; }
    .po-filter-bar .po-filters-badge { margin-left: 0 !important; }
    .po-page-header { margin-top: 8px !important; padding: 10px 12px !important; }
    .po-page-header h1 { font-size: 14px !important; }

    /* Make ReactTable scroll horizontally on mobile */
    .pharmacy-orders-page .revamp-table.ReactTable { font-size: 11px !important; }
    .pharmacy-orders-page .rt-table { overflow-x: auto !important; -webkit-overflow-scrolling: touch !important; }
    .pharmacy-orders-page .rt-thead .rt-th,
    .pharmacy-orders-page .rt-tbody .rt-td { min-width: 80px !important; }

    /* Date picker calendar position fix on mobile */
    .DateRangePicker_picker { position: fixed !important; top: 50% !important; left: 50% !important; transform: translate(-50%, -50%) !important; z-index: 9999 !important; }
  }

  /* ── Modal Mobile Responsiveness ── */
  @media (max-width: 640px) {
    /* Shrink all modal dialogs to fit screen */
    .modal-dialog {
      max-width: calc(100vw - 16px) !important;
      width: calc(100vw - 16px) !important;
      margin: 8px auto !important;
    }
    .modal-content {
      border-radius: 12px !important;
      max-height: 92vh !important;
      display: flex !important;
      flex-direction: column !important;
    }

    /* Compact header */
    .modal-header {
      padding: 12px 16px !important;
      flex-shrink: 0 !important;
    }
    .modal-header .modal-title {
      font-size: 15px !important;
      font-weight: 700 !important;
    }

    /* Scrollable body with reduced padding */
    .modal-body {
      padding: 14px 16px !important;
      overflow-y: auto !important;
      overflow-x: hidden !important;
      -webkit-overflow-scrolling: touch !important;
      flex: 1 !important;
    }

    /* Prevent iOS zoom on inputs */
    .modal-body input,
    .modal-body select,
    .modal-body textarea {
      font-size: 16px !important;
    }

    /* Stack form labels above inputs */
    .modal-body .form-group label {
      font-size: 12px !important;
      margin-bottom: 4px !important;
    }
    .modal-body .form-group {
      margin-bottom: 12px !important;
    }

    /* Horizontal scroll for tables inside modals */
    .modal-body .table-responsive { overflow-x: auto !important; }
    .modal-body table { font-size: 11px !important; white-space: nowrap !important; }
    .modal-body .ReactTable { font-size: 11px !important; }
    .modal-body .rt-table { overflow-x: auto !important; -webkit-overflow-scrolling: touch !important; }

    /* Stack footer buttons vertically */
    .modal-footer {
      padding: 10px 16px !important;
      flex-direction: column !important;
      gap: 8px !important;
      flex-shrink: 0 !important;
    }
    .modal-footer .btn,
    .modal-footer button {
      width: 100% !important;
      margin: 0 !important;
    }

    /* Flex rows inside modals wrap on mobile */
    .modal-body .row { margin: 0 !important; }
    .modal-body .col,
    .modal-body [class*="col-"] {
      padding: 0 !important;
      margin-bottom: 10px !important;
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
  }
`;

class PharmacyOrdersHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      startDateDelivered: null,
      endDateDelivered: null,
      focusedInputDelivered: null,
      focusedInput: null,
      focusedInputCollection: null,
      phone: null,
      isUploadPrescritionModalOpened: false,
      isAddApolloMedicineOpened: false,
      isShowRefundOrderModal: false,
      isShowRefundBankAmountModal: false,
      isShowAnalytics: false,
    };
  }

  componentDidMount() {
    this.props.closeSidebar();
  }

  showUploadPrescriptionModal = () => {
    this.setState({ isUploadPrescritionModalOpened: !this.state.isUploadPrescritionModalOpened });
  }

    showAddApolloMedicineModal = () => {
    this.setState({ isAddApolloMedicineOpened: !this.state.isAddApolloMedicineOpened });
  }

  showRefundOrderModal = () => {
    this.setState({ isShowRefundOrderModal: !this.state.isShowRefundOrderModal });
  }

  showRefundBankAmountModal = () => {
    this.setState({ isShowRefundBankAmountModal: !this.state.isShowRefundBankAmountModal });
  }
  onDatesChanged = ({ startDate, endDate }) => {
    this.setState({ startDate, endDate });
  };

  onDeliveryDatesChanged = ({ startDate, endDate }) => {
    console.log(startDate, endDate);
    this.setState({ startDateDelivered: startDate, endDateDelivered: endDate });
  };

  onPhoneSearch = (e) => {
    const phone = e.target.value.trim();
    console.log(phone);
    this.setState({ phone });
  }

  render() {
    const { startDate, endDate, startDateDelivered, endDateDelivered, focusedInput, focusedInputDelivered, phone } = this.state;
    return (
      <div className="pharmacy-orders-page" style={{ width: '100%' }}>
        { this.state.isUploadPrescritionModalOpened &&
          <div>
            <UploadRxModal onClose={this.showUploadPrescriptionModal} />
          </div>
        }
        { this.state.isAddApolloMedicineOpened &&
          <div>
            <AddApolloMedicineModal onClose={this.showAddApolloMedicineModal} />
          </div>
        }
        { this.state.isShowRefundOrderModal &&
          <div>
            <RefundOrderModal onClose={this.showRefundOrderModal} />
          </div>
        }
        { this.state.isShowRefundBankAmountModal &&
          <div>
            <RefundBankAmountModal onClose={this.showRefundBankAmountModal} />
          </div>
        }
        {this.state.isShowAnalytics && <OpsAnalyticsModal onClose={() => this.setState({ isShowAnalytics: false })} />}
        <GlobalStyles />
        <div className="container-fluid px-0" style={{ paddingTop: '60px' }}>

          <NavBar />

          {/* ── Content ── */}
          <div className="po-content" style={{ padding: '8px 24px 32px' }}>

            {/* Search + Date filters */}
            <div className="po-filter-bar" style={{
              background: '#fff', border: '1px solid #E3E3E3', borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.04)', padding: '12px 16px',
              display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '10px',
              marginBottom: '16px',
            }}>
              {/* Title */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '7px', flexShrink: 0 }}>
                <span style={{ fontSize: '16px' }}>💊</span>
                <span style={{ fontSize: '14px', fontWeight: 700, color: '#0F0B28', whiteSpace: 'nowrap', letterSpacing: '-0.2px' }}>Pharmacy Orders</span>
              </div>

              <div className="po-divider" style={{ width: '1px', height: '24px', background: '#E3E3E3', flexShrink: 0 }} />

              {/* Search */}
              <div className="po-search-wrap" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <svg style={{ position: 'absolute', left: '10px', pointerEvents: 'none', opacity: 0.4 }} width="13" height="13" viewBox="0 0 16 16" fill="none">
                  <circle cx="6.5" cy="6.5" r="5" stroke="#585969" strokeWidth="2" />
                  <line x1="10.5" y1="10.5" x2="14" y2="14" stroke="#585969" strokeWidth="2" strokeLinecap="round" />
                </svg>
                <input
                  placeholder="Search by phone..."
                  style={{
                    height: '34px', width: '220px',
                    paddingLeft: '30px', paddingRight: '10px',
                    fontSize: '12px', color: '#0F0B28', background: '#FAFAFA',
                    border: '1px solid #E3E3E3', borderRadius: '6px',
                    outline: 'none', transition: 'border-color 0.15s',
                  }}
                  onFocus={e => (e.target.style.borderColor = '#6C5DD3')}
                  onBlur={e => (e.target.style.borderColor = '#E3E3E3')}
                  onKeyDown={(e) => e.key === 'Enter' ? this.onPhoneSearch(e) : null}
                />
              </div>

              <div className="po-divider" style={{ width: '1px', height: '24px', background: '#E3E3E3', flexShrink: 0 }} />

              {/* Booking Date */}
              <div className="po-date-group" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span style={{ fontSize: '11px', fontWeight: 600, color: '#585969', whiteSpace: 'nowrap' }}>📅 Booking</span>
                <DateRangePicker
                  displayFormat={() => 'DD/MM/YY'}
                  startDateId="startDate" endDateId="endDate"
                  startDate={startDate} endDate={endDate}
                  isOutsideRange={() => false} minimumNights={0}
                  onDatesChange={this.onDatesChanged}
                  focusedInput={focusedInput}
                  onFocusChange={(focusedInput) => this.setState({ focusedInput })}
                  small noBorder
                />
              </div>

              <div className="po-divider" style={{ width: '1px', height: '24px', background: '#E3E3E3', flexShrink: 0 }} />

              {/* Delivery Date */}
              <div className="po-date-group" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span style={{ fontSize: '11px', fontWeight: 600, color: '#585969', whiteSpace: 'nowrap' }}>🚚 Delivery</span>
                <DateRangePicker
                  displayFormat={() => 'DD/MM/YY'}
                  startDateId="startDateDelivered" endDateId="endDateDelivered"
                  startDate={startDateDelivered} endDate={endDateDelivered}
                  isOutsideRange={() => false} minimumNights={0}
                  onDatesChange={this.onDeliveryDatesChanged}
                  focusedInput={focusedInputDelivered}
                  onFocusChange={(focusedInputDelivered) => this.setState({ focusedInputDelivered })}
                  small noBorder
                />
              </div>

              {/* Right-aligned: filters badge + action buttons */}
              <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '8px' }}>
                {(startDate || endDate || startDateDelivered || endDateDelivered || phone) && (
                  <span className="po-filters-badge" style={{
                    display: 'inline-flex', alignItems: 'center', gap: '4px',
                    fontSize: '11px', fontWeight: 600, color: '#6C5DD3',
                    background: '#F5F4FF', border: '1px solid #E5E9FE',
                    borderRadius: '10px', padding: '2px 10px',
                  }}>
                    <span style={{ width: '5px', height: '5px', borderRadius: '50%', background: '#6C5DD3', display: 'inline-block' }} />
                    Filters active
                  </span>
                )}
                <div style={{ width: '1px', height: '20px', background: '#E3E3E3', flexShrink: 0 }} />
                <button
                  onClick={() => this.setState({ isShowAnalytics: true })}
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: '5px',
                    padding: '5px 11px', borderRadius: '6px',
                    background: '#fff', color: '#0F0B28',
                    fontSize: '12px', fontWeight: 600,
                    border: '1px solid #E3E3E3',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                    cursor: 'pointer', whiteSpace: 'nowrap',
                  }}
                >Analytics</button>
                <Link
                  to="/pharmacy-scan-and-pay"
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: '4px',
                    padding: '5px 11px', borderRadius: '6px',
                    background: '#6C5DD3', color: '#fff',
                    fontSize: '12px', fontWeight: 600,
                    textDecoration: 'none', whiteSpace: 'nowrap',
                    boxShadow: '0 1px 3px rgba(108,93,211,0.25)',
                  }}
                >Scan &amp; Pay →</Link>
              </div>
            </div>

            <PharmacyOrdersTable startDate={startDate} endDate={endDate} startDateDelivered={startDateDelivered} endDateDelivered={endDateDelivered} showUploadPrescriptionModal={this.showUploadPrescriptionModal} showAddApolloMedicineModal={this.showAddApolloMedicineModal} phone={phone} showRefundOrderModal={this.showRefundOrderModal} showRefundBankAmountModal={this.showRefundBankAmountModal} />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return;
}

const mapDispatchToProps = (dispatch) => ({
  closeSidebar: () => dispatch(toggleSidebar(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PharmacyOrdersHome);

